import { TRIAL_STATUS_ID } from '@witmetrics/utils/constants';
import type { DecoratedAccountTrial } from '@witmetrics/utils';
import { DAY_MS, GRADIENTS } from './constants';

export const classes = {
  card: 'group flex w-full items-center gap-3 rounded-[15px] border border-white/70 bg-white/70 px-[14px] py-3 text-left shadow-aurora-card transition-[box-shadow,border-color] duration-[160ms] ease-[ease] hover:border-brand-accent/55 hover:shadow-[0_18px_34px_-16px_rgba(241,90,43,0.4)] dark:border-white/[0.08] dark:bg-white/[0.05] dark:hover:border-brand-accent-dark/50',
  badge:
    'flex size-[38px] flex-none items-center justify-center rounded-[12px] text-[12px] font-extrabold text-white',
  info: 'min-w-0 flex-1',
  name: 'truncate text-[14.5px] font-semibold text-taupe-3 dark:text-mauve-1',
  trial:
    'mt-1.5 inline-flex items-center gap-[5px] whitespace-nowrap rounded-full bg-[#0891b2]/[0.15] px-[9px] py-0.5 text-[10.5px] font-bold text-[#0e7490] dark:bg-[#22d3ee]/[0.16] dark:text-[#67e8f9]',
  chevron:
    'size-[17px] flex-none -translate-x-[5px] text-brand-accent opacity-0 transition-[opacity,transform] duration-[160ms] ease-[ease] group-hover:translate-x-0 group-hover:opacity-100 dark:text-brand-accent-dark',
};

function hashName(name: string) {
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = (hash * 31 + name.charCodeAt(i)) >>> 0;
  }
  return hash;
}

export function getBadgeStyle(name: string) {
  const [from, to] = GRADIENTS[hashName(name) % GRADIENTS.length];
  return {
    background: `linear-gradient(135deg,${from},${to})`,
    boxShadow: `0 9px 20px -8px color-mix(in srgb,${from} 65%,transparent)`,
  };
}

export function getTrialLabel(
  trials: DecoratedAccountTrial[]
): string | undefined {
  const active = trials.find(
    (trial) => trial.trialStatusId === TRIAL_STATUS_ID.ACTIVE && trial.endsAt
  );
  if (!active?.endsAt) return undefined;
  const msLeft = new Date(active.endsAt).getTime() - Date.now();
  if (msLeft <= 0) return undefined;
  const days = Math.ceil(msLeft / DAY_MS);
  return `Trial · ${days} day${days === 1 ? '' : 's'} remaining`;
}
